import {
  useFieldArray,
  useWatch,
  UseFormReturn,
  FieldValues,
  Path,
  ArrayPath,
  FieldArray,
} from 'react-hook-form';

interface UseFormArrayProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: ArrayPath<T>;
  maxItems?: number;
  minItems?: number;
}

export function useFormArray<T extends FieldValues>({
  form,
  name,
  maxItems,
  minItems = 1,
}: UseFormArrayProps<T>) {
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name,
  });

  const items = useWatch({
    control: form.control,
    name: name as Path<T>,
  });

  const canAdd = maxItems ? (items?.length || 0) < maxItems : true;
  const canRemove = (items?.length || 0) > minItems;

  const handleAdd = (item: FieldArray<T, ArrayPath<T>>) => {
    if (canAdd) {
      append(item);
    }
  };

  const handleRemove = (index: number) => {
    if (canRemove) {
      remove(index);
    }
  };

  return {
    fields,
    items,
    canAdd,
    canRemove,
    handleAdd,
    handleRemove,
  };
}
